import { useParams } from 'react-router'

export const useCurrentExternalDataSourceUuid = () => {
  const { uuid } = useParams<{ uuid: string }>()
  return uuid
}

export default useCurrentExternalDataSourceUuid
